/* eslint-disable @typescript-eslint/consistent-type-definitions */
import { darken, experimental_extendTheme as extendTheme } from '@mui/material';

const theme = extendTheme({
  components: {
    MuiButton: {
      defaultProps: {
        focusRipple: false,
      },
      variants: [
        {
          props: { variant: 'rounded' },
          style: {
            // textTransform: 'none',
            // border: '2px dashed #757ce8',
            // borderRadius: '10px',
            // '&:hover': {
            //   backgroundColor: '#757ce8',
            // },
          },
        },
      ],
      styleOverrides: {
        root: ({ theme, ownerState }) => {
          const mainButton = {
            borderRadius: '50px',
            fontSize: '1em',
            fontWeight: 500,
            // textTransform: 'none',
            boxShadow: 'none',
            paddingTop: '6px',
            paddingBottom: '6px',
            paddingLeft: theme.spacing(3),
            paddingRight: theme.spacing(3),
          };
          if (ownerState.variant === 'rounded') {
            return {
              // @ts-ignore
              backgroundColor: theme.vars.palette[ownerState.color].main,
              // @ts-ignore
              color: theme.palette[ownerState.color].contrastText,
              '&:hover': {
                backgroundColor: `${darken(
                  // @ts-ignore
                  theme.palette[ownerState.color].main,
                  0.2
                )}`,
              },
              '&.Mui-disabled': {
                backgroundColor: theme.palette.action.disabledBackground,
                boxShadow: 'none',
              },
              border: 0,
              textTransform: 'none',
              ...mainButton,
            };
          } else if (ownerState.variant === 'roundedBorder') {
            return {
              // @ts-ignore
              borderColor: theme.palette[ownerState.color].main,
              // @ts-ignore
              border: '1px solid',
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              color: theme.palette[ownerState.color].main,
              '&:hover': {
                backgroundColor: theme.palette.action.hover,
              },
              '&.Mui-disabled': {
                backgroundColor: theme.palette.action.disabledBackground,
                boxShadow: 'none',
              },
              textTransform: 'none',
              ...mainButton,
            };
          } else if (ownerState.variant === 'roundedBorderInvert') {
            return {
              // @ts-ignore
              borderColor: theme.palette[ownerState.color].contrastText,
              // @ts-ignore
              border: '1px solid',
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              color: theme.palette[ownerState.color].contrastText,
              '&:hover': {
                backgroundColor: theme.palette.action.hover,
              },
              '&.Mui-disabled': {
                backgroundColor: theme.palette.action.disabledBackground,
                boxShadow: 'none',
              },
              textTransform: 'none',
              ...mainButton,
            };
          } else if (ownerState.variant === 'roundedInvert') {
            return {
              // @ts-ignore
              backgroundColor: theme.vars.palette[ownerState.color].contrastText,
              // @ts-ignore
              color: theme.palette[ownerState.color].main,
              '&:hover': {
                backgroundColor: `${darken(
                  // @ts-ignore
                  theme.palette[ownerState.color].contrastText,
                  0.2
                )}`,
              },
              '&.Mui-disabled': {
                backgroundColor: theme.palette.action.disabledBackground,
                boxShadow: 'none',
              },
              border: 0,
              textTransform: 'none',
              ...mainButton,
            };
          } else {
            return {
              textTransform: 'none',
              fontWeight: 'normal',
            };
          }
        },
      },
    },
  },
});

export const buttonTheme = theme.components?.MuiButton;

declare module '@mui/material/Button' {
  interface ButtonPropsVariantOverrides {
    rounded: true;
    roundedBorder: true;
    roundedInvert: true;
    roundedBorderInvert: true;
  }
}

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    black: true;
    textSecondary: true;
  }
}
